import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../utils/api.utils";
import { useState } from "react";
import { Toast, Form, InputGroup } from "react-bootstrap";

export const TrackingComplaint = ({
  loading,
  setLoading,
  message,
  setMessage,
}) => {
  const { protocolo_id, pass_protocolo } = useParams();

  const navigate = useNavigate();

  const [dataAPI, setDataAPI] = useState();
  const [messageUser, setMessageUser] = useState("");

  useEffect(() => {
    const getData = async () => {
      try {
        const data = await api.trackComplaint(protocolo_id, pass_protocolo);
        setDataAPI(data);
        setLoading(false);
      } catch (error) {
        console.log(error, "Error to get data");
      }
    };
    getData();
  }, [setLoading, protocolo_id, pass_protocolo]);

  let user = "anônimo";
  let statusAtual = "";
  let newStatus = "";
  dataAPI?.forEach((denuncia) => {
    user = denuncia.complaint_ID.name;

    if (denuncia.complaint_ID.status === "cadastrada") {
      newStatus = "RECEBIDA";
      statusAtual = "warning";
    } else if (denuncia.complaint_ID.status === "finalizado") {
      statusAtual = "secondary";
      newStatus = "finalizado";
    } else if (denuncia.complaint_ID.status === "em-andamento") {
      statusAtual = "info";
      newStatus = "em andamento";
    } else
      denuncia.complaint_ID.status = denuncia.complaint_ID.status
        .toUpperCase()
        .replace("-", " ");
  });

  const handleSendMessage = async (e) => {
    e.preventDefault();

    setMessageUser(messageUser);

    try {
      await api.sendMessageUser(
        protocolo_id,
        pass_protocolo,
        { messageUser },
        { user }
      );
      navigate(0);
    } catch (error) {
      setMessage(error);
    }
  };

  return !loading ? (
    <div className="d-flex justify-content-center w-100">
      {dataAPI?.map((complaint, index) => {
        let anoDen = complaint.createdAt.slice(0, 4);
        return (
          <div className="w-100 container" key={index}>
            <div className="w-100 d-flex justify-content-end px-3 mt-3"></div>
            <div
              className="align-mobile d-flex flex-nowrap 
            w-100 align-items-start"
            >
              <div className="card w-50 m-3">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h6 className="fs-6">Dados da Denúncia</h6>
                  <span className={` rounded p-2  alert-${statusAtual}`}>
                    {newStatus || complaint.status}
                  </span>
                </div>
                <div className="card-body no-shadow">
                  <p className="card-text w-100 d-flex flex-column flex-start no-shadow">
                    <span>
                      <strong>Data: </strong>
                      {new Intl.DateTimeFormat("default", {
                        timeZone: "America/Sao_Paulo",
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      }).format(new Date(complaint.createdAt))}
                      h
                    </span>
                    <span>
                      <strong>
                        Protocolo: {anoDen}DEN{complaint.protocolo_id}
                      </strong>
                    </span>
                    {complaint.complaint_ID.previousComplaint && (
                      <span>
                        <strong>Denúncia anterior:</strong>
                        {complaint.complaint_ID.previousComplaint}
                      </span>
                    )}

                    {complaint.complaint_ID.name ? (
                      <>
                        <span>
                          <strong>Nome: </strong>
                          {complaint.complaint_ID.name}
                        </span>
                        <span>
                          <strong>E-mail: </strong>
                          {complaint.complaint_ID.email}
                        </span>
                        <span>
                          <strong>Telefone: </strong>
                          {complaint.complaint_ID.telephone}
                        </span>
                      </>
                    ) : (
                      <>
                        <b>Denúncia Anônima</b>
                      </>
                    )}
                    <span>
                      <strong>Categoria:</strong>{" "}
                      {complaint.complaint_ID.category}
                    </span>

                    <span>
                      <strong>Envolvidos: </strong>
                      {complaint.complaint_ID.involved || "-"}
                    </span>
                    <span>
                      <strong>Quem presenciou: </strong>
                      {complaint.complaint_ID.witness || "-"}
                    </span>
                    <span>
                      <strong>Conversou com: </strong>
                      {complaint.complaint_ID.talkedAbout || "-"}
                    </span>
                  </p>
                </div>
              </div>
              <div className="card w-50 m-3">
                <div className="d-flex card-header justify-content-between align-items-center">
                  <h5 className=" mb-0 w-100 text-center">Mensagens</h5>
                </div>
                <div className="card-body no-shadow">
                  {
                    <Toast className={` mb-2`}>
                      <Toast.Header closeButton={false}>
                        <i className="bi bi-person-circle"> </i>
                        <strong className="me-auto mx-2">
                          {" "}
                          {complaint.name || "Anônimo"}
                        </strong>
                        <small>
                          {new Intl.DateTimeFormat("default", {
                            timeZone: "America/Sao_Paulo",
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                          }).format(new Date(complaint.createdAt))}
                          h
                        </small>
                      </Toast.Header>
                      <Toast.Body>{complaint.details || "Vazio"}</Toast.Body>
                    </Toast>
                  }

                  {complaint?.complaint_ID?.messages_id.map(
                    (message, index) => {
                      let styleOuvi = "";
                      if (message.userId) {
                        styleOuvi = "styleOuvidoria";
                      }

                      return (
                        <Toast key={index} className={`${styleOuvi} mb-2`}>
                          <Toast.Header
                            closeButton={false}
                            className={`${styleOuvi}`}
                          >
                            <i className="bi bi-person-circle"> </i>
                            <strong className="me-auto mx-2">
                              {" "}
                              {message.userId
                                ? "Membro do comitê"
                                : message.userName}
                            </strong>
                            <small>
                              {new Intl.DateTimeFormat("default", {
                                timeZone: "America/Sao_Paulo",
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: false,
                              }).format(new Date(message.createdAt))}
                              h
                            </small>
                          </Toast.Header>
                          <Toast.Body className={`${styleOuvi}`}>
                            {message.descricao}
                          </Toast.Body>
                        </Toast>
                      );
                    }
                  )}
                  {complaint?.complaint_ID?.etapa !== "ouvidoria" ? (
                    <form className="w-100 mt-3">
                      <p>Digite aqui sua mensagem:</p>
                      <InputGroup className="mb-3">
                        <Form.Control
                          as="textarea"
                          atial-label="Message"
                          value={messageUser}
                          onChange={(e) => setMessageUser(e.target.value)}
                        />
                        <button
                          className="btn btn-primary"
                          onClick={handleSendMessage}
                        >
                          <i className="bi bi-send-fill"></i>
                        </button>
                      </InputGroup>
                    </form>
                  ) : (
                    <>Aguardando resposta do comitê de denúncia.</>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  ) : null;
};
